import type { Location as SolidLocation } from "@solidjs/router";

export const urls = {
  chatPage: (chatId: string) => `/chat/${chatId}`,
};

/**
 * Rebuilds the full path from a location object.
 * @param location - The location object returned from `useLocation()`
 * @returns {string}
 * @example
 * ```ts
 * const location = useLocation();
 * const fullPath = rebuildHref(location);
 * ```
 */
export const rebuildFullPath = (location: SolidLocation<unknown> | Location): string => {
  const search = location.search && location.search !== "?" ? location.search : "";
  const hash = location.hash && location.hash !== "#" ? location.hash : "";
  return location.pathname + search + hash;
};
